/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadLogsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type UploadLogsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Encoding applied to the OTLP request body. Supported values are gzip and identity.
   */
  contentEncoding?: string | undefined;
};

/** @internal */
export type UploadLogsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const UploadLogsSecurity$outboundSchema: z.ZodMiniType<
  UploadLogsSecurity$Outbound,
  UploadLogsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadLogsSecurityToJSON(
  uploadLogsSecurity: UploadLogsSecurity,
): string {
  return JSON.stringify(
    UploadLogsSecurity$outboundSchema.parse(uploadLogsSecurity),
  );
}

/** @internal */
export type UploadLogsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Content-Encoding"?: string | undefined;
};

/** @internal */
export const UploadLogsRequest$outboundSchema: z.ZodMiniType<
  UploadLogsRequest$Outbound,
  UploadLogsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    contentEncoding: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      contentEncoding: "Content-Encoding",
    });
  }),
);

export function uploadLogsRequestToJSON(
  uploadLogsRequest: UploadLogsRequest,
): string {
  return JSON.stringify(
    UploadLogsRequest$outboundSchema.parse(uploadLogsRequest),
  );
}
